import { render, staticRenderFns } from "./bizmenu.vue?vue&type=template&id=05444800&scoped=true&"
import script from "./bizmenu.vue?vue&type=script&lang=js&"
export * from "./bizmenu.vue?vue&type=script&lang=js&"
import style0 from "./bizmenu.vue?vue&type=style&index=0&id=05444800&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05444800",
  null
  
)

export default component.exports